// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.data-url_code_kfd0N {
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    height: 5rem;
    min-height: 3rem;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    padding: 0.25rem;
    font-size: 0.875rem;
    font-family: monospace;
    margin: 0.5rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-security-manager-modal/data-url.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,6CAA6C;IAC7C,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.code {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    min-width: 100%;\n    height: 5rem;\n    min-height: 3rem;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    padding: 0.25rem;\n    font-size: 0.875rem;\n    font-family: monospace;\n    margin: 0.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
export var code = `data-url_code_kfd0N`;
export default ___CSS_LOADER_EXPORT___;
